import React from 'react'
import './Loader.scss'

const Loader = (props) => {
  return (
    <React.Fragment>
      <div className="loader">
        <div className="lds-facebook">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Loader
